import { Link, Page, Text, View } from '@react-pdf/renderer'
import { format } from 'date-fns'
import { Html } from 'react-pdf-html'
import { tw } from '~/components/reports'
import { cn, fmtAddress } from '~/lib'
import type { Client, Listing, ReportPdfOptions } from '~/models'
import PdfClientBrokerProfile from './ec-dev-contact'

function PdfNotes({ notes }: { notes?: string }) {
  if (!notes) return null
  return (
    <Html
      style={tw('mt-4 font-sans text-base leading-normal')}
      stylesheet={{
        p: { margin: '0 0 10px' },
        li: { margin: 0 },
        ul: { margin: 0 },
        'ul > ul': { margin: 0 },
      }}>
      {notes}
    </Html>
  )
}

function PdfPreparedFor({ preparedFor }: { preparedFor?: string }) {
  if (!preparedFor) {
    return (
      <Text style={tw('font-sans text-base text-muted')}>
        Prepared on {format(new Date(), 'PPP')}
      </Text>
    )
  }
  return (
    <Text style={tw('font-sans text-base text-muted')}>
      Prepared for {preparedFor} on {format(new Date(), 'PPP')}
    </Text>
  )
}

export default function ReportPdfTitlePage({
  title,
  listings,
  pdfOptions,
  orientation,
  client,
}: {
  title: string
  listings: Listing[]
  pdfOptions: ReportPdfOptions
  orientation: 'portrait' | 'landscape'
  client: Client
}) {
  const renderContents = () => {
    if (!pdfOptions.showContents) return null
    return (
      <View style={tw('mt-8')}>
        <Text style={tw('font-heading mb-4 text-lg leading-none')}>
          Table of Contents
        </Text>
        <View style={tw('flex flex-col gap-1')}>
          {listings.map((listing, index) => {
            return (
              <View key={listing.id} style={tw('flex flex-row')}>
                <Text
                  style={tw(
                    cn('text-base', listings.length > 99 ? 'w-8' : 'w-6')
                  )}>
                  {index + 1}.
                </Text>
                <Link style={tw('text-base text-black')} src={`#${listing.id}`}>
                  {fmtAddress(listing.property, true)}
                </Link>
              </View>
            )
          })}
        </View>
      </View>
    )
  }

  return (
    <Page size="LETTER" style={tw('font-sans')} orientation={orientation}>
      <View style={tw('flex flex-row')}>
        <View style={tw(cn('p-8', pdfOptions.showEcDevContact && 'w-2/3'))}>
          {/* <View style={tw('p-8')}> */}
          <Text style={tw('font-heading mb-2 text-3xl leading-tight')}>
            {title}
          </Text>
          <PdfPreparedFor preparedFor={pdfOptions.preparedFor} />
          <PdfNotes notes={pdfOptions.notes} />
          {renderContents()}
        </View>
        {pdfOptions.showEcDevContact && (
          <PdfClientBrokerProfile client={client} orientation={orientation} />
        )}
      </View>
    </Page>
  )
}
